import { useOptionalVersioning } from '@/data/context/VersioningContext';
import Lesson from '@/models/Lesson';
import { RunEditableOptions } from '@/utils/shared/createVersioningSession';

export const useEditableLesson = (lessonId: number) => {
  const session = useOptionalVersioning<Lesson>();
  const runEditable = <R>(
    action: (lessonId: number) => Promise<R>,
    options?: RunEditableOptions,
  ) =>
    session
      ? session.runEditable(lesson => action(lesson.id), options)
      : action(lessonId);
  return { runEditable };
};
